module.exports = __webpack_public_path__ + "img/symbol_2.3232b0d6.png";